import { registerSymbol } from './index';
import { Line, Path, Circle, Rect, Polygon, } from '../element';
registerSymbol('none', Rect, function (x, y) {
    return { x: x, y: y };
});
registerSymbol('circle', Circle, function (x, y, width, height) {
    var cx = x + width / 2;
    var cy = y + height / 2;
    var r = Math.min(width, height) / 2;
    return {
        cx: cx,
        cy: cy,
        radius: r,
    };
});
registerSymbol('rect', Rect, function (x, y, width, height) {
    return { x: x, y: y, width: width, height: height };
});
registerSymbol('roundRect', Rect, function (x, y, width, height) {
    return {
        x: x,
        y: y,
        width: width,
        height: height,
        r: Math.min(width, height) / 4,
    };
});
registerSymbol('triangle', Polygon, function (x, y, width, height) {
    return {
        pointList: [
            {
                x: x + width / 2,
                y: y,
            },
            {
                x: x + width,
                y: y + height,
            },
            {
                x: x,
                y: y + height,
            },
        ],
    };
});
registerSymbol('diamond', Polygon, function (x, y, width, height) {
    return {
        pointList: [
            {
                x: x + width / 2,
                y: y,
            },
            {
                x: x + width,
                y: y + height / 2,
            },
            {
                x: x + width / 2,
                y: y + height,
            },
            {
                x: x,
                y: y + height / 2,
            },
        ],
    };
});
registerSymbol('pin', Path, function (x, y, width, height) {
    x += width / 2;
    y += height / 2;
    return {
        brush: function (ctx) {
            var w = (width / 5) * 3;
            // Height must be larger than width
            var h = Math.max(w, height);
            var r = w / 2;
            // Dist on y with tangent point and circle center
            var dy = (r * r) / (h - r);
            var cy = y - h + r + dy;
            var angle = Math.asin(dy / r);
            // Dist on x with tangent point and circle center
            var dx = Math.cos(angle) * r;
            var tanX = Math.sin(angle);
            var tanY = Math.cos(angle);
            var cpLen = r * 0.6;
            var cpLen2 = r * 0.7;
            ctx.moveTo(x - dx, cy + dy);
            ctx.arc(x, cy, r, Math.PI - angle, Math.PI * 2 + angle);
            ctx.bezierCurveTo(x + dx - tanX * cpLen, cy + dy + tanY * cpLen, x, y - cpLen2, x, y);
            ctx.bezierCurveTo(x, y - cpLen2, x - dx + tanX * cpLen, cy + dy + tanY * cpLen, x - dx, cy + dy);
            ctx.closePath();
        },
    };
});
registerSymbol('gaugePointer', Path, function (x, y, width, height) {
    return {
        brush: function (ctx) {
            ctx.moveTo(x + width / 2, y);
            ctx.lineTo(x + width, y + height);
            ctx.lineTo(x + width / 2, y + height + (width * Math.sqrt(3)) / 2);
            ctx.lineTo(x, y + height);
            ctx.closePath();
        },
    };
});
registerSymbol('star', Polygon, function (x, y, width, height) {
    var points = [];
    var size = Math.min(width, height);
    var cx = x + width / 2;
    var cy = y + height / 2;
    var r1 = size / 2;
    var r2 = r1 / 2;
    for (var i = 0; i < 5; i++) {
        points.push({
            x: cx + r2 * Math.cos(((18 + i * 72) / 180) * Math.PI),
            y: cy + r2 * Math.sin(((18 + i * 72) / 180) * Math.PI),
        });
        points.push({
            x: cx + r1 * Math.cos(((54 + i * 72) / 180) * Math.PI),
            y: cy + r1 * Math.sin(((54 + i * 72) / 180) * Math.PI),
        });
    }
    return {
        pointList: points,
    };
});
registerSymbol('tooltip', Path, function (x, y, width, height) {
    var r = 2;
    var arrowWidth = 8;
    var arrowHeight = 4;
    y -= height / 2;
    y -= arrowHeight;
    y -= 2;
    return {
        brush: function (ctx) {
            ctx.arc(x + r, y + r, r, -Math.PI, -Math.PI / 2);
            ctx.lineTo(x + width - r, y);
            ctx.arc(x + width - r, y + r, r, -Math.PI / 2, 0);
            ctx.lineTo(x + width, y + height - r);
            ctx.arc(x + width - r, y + height - r, r, 0, Math.PI / 2);
            ctx.lineTo(x + width / 2 + arrowWidth / 2, y + height);
            ctx.lineTo(x + width / 2, y + height + arrowHeight);
            ctx.lineTo(x + width / 2 - arrowWidth / 2, y + height);
            ctx.lineTo(x + r, y + height);
            ctx.arc(x + r, y + height - r, r, Math.PI / 2, Math.PI);
            ctx.closePath();
        },
    };
});
function getCaretPoints(x, y, width, height, side) {
    var points = [];
    if (side === 'top') {
        points.push({
            x: x + width / 2,
            y: y,
        });
        points.push({
            x: x,
            y: y + height,
        });
        points.push({
            x: x + width,
            y: y + height,
        });
    }
    else if (side === 'bottom') {
        points.push({
            x: x,
            y: y,
        });
        points.push({
            x: x + width,
            y: y,
        });
        points.push({
            x: x + width / 2,
            y: y + height,
        });
    }
    else if (side === 'left') {
        points.push({
            x: x,
            y: y + height / 2,
        });
        points.push({
            x: x + width,
            y: y,
        });
        points.push({
            x: x + width,
            y: y + height,
        });
    }
    else if (side === 'right') {
        points.push({
            x: x + width,
            y: y + height / 2,
        });
        points.push({
            x: x,
            y: y,
        });
        points.push({
            x: x,
            y: y + height,
        });
    }
    return points;
}
registerSymbol('caretUp', Polygon, function (x, y, width, height) {
    return {
        pointList: getCaretPoints(x, y, width, height, 'top'),
    };
});
registerSymbol('caretDown', Polygon, function (x, y, width, height) {
    return {
        pointList: getCaretPoints(x, y, width, height, 'bottom'),
    };
});
registerSymbol('caretLeft', Polygon, function (x, y, width, height) {
    return {
        pointList: getCaretPoints(x, y, width, height, 'left'),
    };
});
registerSymbol('caretRight', Polygon, function (x, y, width, height) {
    return {
        pointList: getCaretPoints(x, y, width, height, 'right'),
    };
});
registerSymbol('line', Line, function (x, y, width, height) {
    var cy = y + height / 2;
    return {
        x1: x,
        y1: cy,
        x2: x + width,
        y2: cy,
    };
});
